export enum InsertionChantierType {
  COMPAGNON_LG = 'COMPAGNON_LG',
  COMPAGNON_ETT = 'COMPAGNON_ETT',
  AUTRE_SALARIE_LG = 'AUTRE_SALARIE_LG',
  AUTRE_CAS = 'AUTRE_CAS',
  SOUS_TRAITANT = 'SOUS_TRAITANT',
  COMPAGNON_SOUS_TRAITANT = 'COMPAGNON_SOUS_TRAITANT'
}
